import React, { useContext } from 'react'
import { DocumentTitle } from 'lib/hooks/useDocumentTitle'
import { RouterContext } from 'domains/application/screens/AppScreen'
import { RouteComponentProps } from 'react-router'
import { View, Text, Button, Icon, Image } from 'lib/components'

interface IProps {
  onGoBack?: () => void
}

interface ISubtitleProps {
  children: any
}
function Subtitle(props: ISubtitleProps) {
  return (
    <Text
      fontSize={[18]}
      lineHeight={['26px']}
      fontWeight={500}
      textAlign="center"
    >
      {props.children}
    </Text>
  )
}

export default function PendingApproval(props: IProps) {
  const router = useContext(RouterContext) as RouteComponentProps

  const onGoBack = () => {
    if (props.onGoBack) {
      props.onGoBack()
    } else {
      router.history.goBack()
    }
  }

  const content = (
    <View flexible="column-center">
      <View variant="paper" width={['auto', 600, 900]} my={[3, 4]} mb={3}>
        <View p={[16, 48]} flexible="column-center">
          <Text
            fontSize={36}
            lineHeight="48px"
            fontWeight={700}
            textAlign="center"
            data-test="generic-error-title"
          >
            Pending Approval
          </Text>

          <Text
            fontSize={24}
            lineHeight="48px"
            fontWeight={400}
            textAlign="center"
            data-test="generic-error-subtitle-h2"
          >
            TrustEd Apps Dashboard Access
          </Text>

          <Icon
            className="fas fa-hourglass-half text-8xl w-auto h-auto max-w-sm max-h-sm m-8"
            color="secondary"
          />

          <View marginBottom={2} data-test="generic-error-subtitle">
            <Subtitle>
              Thank you for applying for an account. Your account is currently
              pending approval by the site administrator.
            </Subtitle>
          </View>

          <Text
            mt={2}
            fontSize={16}
            lineHeight="28px"
            fontWeight={500}
            textAlign="center"
            data-test="generic-error-subtext"
          >
            (You can submit questions/concerns to{' '}
            <a className="break-normal" href="mailto:support@1edtech.org">
              support@1edtech.org
            </a>
            )
          </Text>

          <Image
            src="/images/1EdTechLogo.svg"
            width="auto"
            maxWidth={64}
            maxHeight={64}
            height="auto"
            m={2}
          />
          <Button mt={[3, 4]} variant="complete" onClick={onGoBack}>
            Go Back
          </Button>
        </View>
      </View>
    </View>
  )

  return (
    <View variant="screen">
      <DocumentTitle title="Pending Approval" />
      {content}
    </View>
  )
}
